import React from 'react';

const ConditionalLinkWrapper = ({
  isClickable,
  productUrl,
  ariaLabel,
  children,
  classNames = '',
}: ConditionalLinkProps) => {
  if (isClickable && productUrl) {
    return (
      <a href={productUrl} aria-label={ariaLabel} className={classNames}>
        {children}
      </a>
    );
  }
  return <>{children}</>;
};

interface ConditionalLinkProps {
  isClickable: boolean;
  productUrl: string | null;
  ariaLabel: string;
  children: React.ReactNode;
  classNames?: string;
}

export default ConditionalLinkWrapper;
